// A gravação termina antes de o áudio virar anexo: entre o fim da gravação e o
// attachFile ainda correm o upload direto e o FileReader. Enviar nessa janela
// mandava uma mensagem vazia, sem o áudio ("Conteúdo não suportado" na conversa).
export const isWaitingForRecordedAudio = ({
  hasRecordedAudio,
  attachedFiles,
}) =>
  !!hasRecordedAudio &&
  !(attachedFiles || []).some(file => file?.isRecordedAudio);

export const hasNothingToSend = ({ message, attachedFiles }) =>
  !(message || '').trim() && !(attachedFiles || []).length;
